import { Box, Link } from '@mui/material';

import { Text } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';

export const RenderSocialButtons = ({ text, title, Icon, href }) => {
  return (
    <Link
      href={href}
      sx={{
        border: `1px solid ${COLORS.gray01}`,
        padding: 1,
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          width: '120px',
          margin: 'auto',
          alignSelf: 'center',
          gap: '8px',
          alignItems: 'center',
        }}
      >
        <Icon width={28} height={28} />
        <Box>
          <Text
            sx={{
              textAlign: 'left',
              fontWeight: 500,
              color: COLORS.black06,
              fontSize: 8,
              lineHeight: '14px',
              fontFamily: 'Roboto, sans-serif',
            }}
          >
            {text}
          </Text>
          <Text sx={{ fontWeight: 500, color: COLORS.black08, fontSize: 15, fontFamily: 'Roboto, sans-serif' }}>
            {title}
          </Text>
        </Box>
      </Box>
    </Link>
  );
};
